
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class FormattedText extends Vue {
  @Prop() description!: string;
}
